// =====================================================================================
// FILE: src/constants/assetDestinations.js
// =====================================================================================
// Maps content columns to their valid asset destinations
// This allows asset pickers to show only relevant assets for each column
// ✅ Uses "contains" matching for flexibility across different naming conventions
// =====================================================================================

// ✅ Column to Asset Destination mapping
// Each column key maps to an array of PATTERNS to match (case-insensitive contains)
// e.g., "-bigscreen" will match "MCG-bigscreen", "Marvel-BigScreen", etc.
export const COLUMN_ASSET_FILTER = {
  // Big Screen - TVC (shows both TVC types)
  bigTvc: [
    "-tvc",
    "screen - tvc",
  ],
  
  // Corner Screen - TVC (shows both TVC types)
  cornerTvc: [
    "-tvc",
    "screen - tvc",
  ],
  
  // LED - All Types (all LED content except IPTV)
  ledAllTypes: [
    "-360",
    "-tiled",
    "-ponsford",
    "-overlay",
    "-interchange",
    "-robbie",
    "robbie flowers",
    "dj booth",
    "-dj",
  ],
  
  // Corner Screens - GFX & Videos (shows both screen types)
  cornerGfxVideos: [
    "-cornerscreen",
    "-bigscreen",
    "corner screens - gfx",
    "big screen - gfx",
  ],
  
  // Big Screen - GFX & Videos (shows both screen types)
  bigGfxVideos: [
    "-bigscreen",
    "-cornerscreen",
    "big screen - gfx",
    "corner screens - gfx",
  ],
  
  // SuperScreen columns (Marvel only)
  super169: [
    "superscreen-16:9",
    "-super-16",
    "-super169",
  ],
  superFull: [
    "superscreen-fullscreen",
    "-super-full",
    "-superfull",
  ],
  superSide: [
    "superscreen-side",
    "-super-side",
    "-superside",
  ],
  
  // IPTV GFX
  iptvGfx: [
    "-iptv",
  ],
  
  // MCG specific columns (if used separately)
  mcgTiledLed: [
    "mcg-tiled",
  ],
  mcg360: [
    "mcg-360",
  ],
  mcgInterchange: [
    "mcg-interchange",
  ],
  
  // Marvel specific columns (if used separately)
  marvelTiledLed: [
    "marvel-tiled",
  ],
  marvel360: [
    "marvel-360",
  ],
  marvelInterchange: [
    "marvel-interchange",
  ],
};

// ✅ Helper function to get valid destination patterns for a column
export function getValidDestinationsForColumn(columnKey) {
  return COLUMN_ASSET_FILTER[columnKey] || null; // null means show all assets
}

// ✅ Helper function to filter assets by column using CONTAINS matching
export function filterAssetsByColumn(assets, columnKey) {
  const patterns = getValidDestinationsForColumn(columnKey);
  
  // If no filter defined for this column, show all assets
  if (!patterns || patterns.length === 0) {
    return assets;
  }
  
  // Convert patterns to lowercase for case-insensitive matching
  const lowerPatterns = patterns.map(p => p.toLowerCase());
  
  return assets.filter(asset => {
    const assetDest = (asset.destination || "").toLowerCase();
    // Check if asset destination CONTAINS any of the patterns
    return lowerPatterns.some(pattern => assetDest.includes(pattern));
  });
}
